var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "s-container"
  }, [_c('h2', [_vm._v("切換院區 / 院所")]), _c('p', [_vm._v("請選擇您希望查看的院區，點選後系統將會切換圖文選單，並呈現該院區相關服務內容：")]), _c('b-overlay', {
    attrs: {
      "show": _vm.isLoadingInstitutions || _vm.isUpdatingSelectedInstitution
    }
  }, [_c('div', {
    staticClass: "institution-list"
  }, _vm._l(_vm.availableInstitutions, function (institution) {
    return _c('div', {
      key: institution.display_name,
      class: ['institution-card', {
        'institution-card--selected': _vm.selectedInstitution === institution
      }],
      on: {
        "click": function click($event) {
          _vm.selectedInstitution = institution;
        }
      }
    }, [_c('div', {
      staticClass: "institution-card__name"
    }, [_vm._v(_vm._s(institution.display_name))]), _c('div', {
      staticClass: "institution-card__memo"
    }, [_vm._v(_vm._s(institution.display_memo || institution.display_momo))])]);
  }), 0)]), _c('p', {
    staticClass: "notice-text"
  }, [_vm._v(" 註：當您實體就診或至官網掃描 QR code 後，即可查看該院所之服務。 切換至新院區後，原院所之客服同仁將無法再看見與回覆您的訊息。 ")]), _c('div', {
    staticClass: "footer-nav"
  }, [_c('TongxinNavigation', {
    attrs: {
      "canProceed": _vm.selectedInstitution && !_vm.isUpdatingSelectedInstitution,
      "backButtonIsVisible": true,
      "nextButtonIsVisible": _vm.availableInstitutions.length > 1,
      "textForNextStep": "確認切換"
    },
    on: {
      "back": _vm.handleBack,
      "next": _vm.submit
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }